import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ShapesIcon = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="417.57px"
        height="744.59px"
        viewBox="0 0 417.57 744.59"
        xmlSpace="preserve"
        className={className}
    >
        <g data-shape>
            <g data-shape-inner>
                <rect
                    x="39.87"
                    y="26.23"
                    transform="matrix(0.9841 -0.1778 0.1778 0.9841 -24.9162 32.506)"
                    fill="#E7344B"
                    width="258.1"
                    height="258.1"
                />
            </g>
        </g>
        <g data-shape>
            <g data-shape-inner>
                <circle fill="#3858A4" cx="277.83" cy="406.08" r="136.22" />
            </g>
        </g>
        <g data-shape>
            <g data-shape-inner>
                <polygon fill="#FFE534" points="94.14,741.28 4.2,486.99 283.3,549 " />
            </g>
        </g>
    </svg>
);

ShapesIcon.propTypes = propTypes;
ShapesIcon.defaultProps = defaultProps;

export default ShapesIcon;
